import React from 'react';
import { ArrowUpRightIcon, ChevronRightIcon, MinusIcon, TrendingDownIcon, TrendingUpIcon } from 'lucide-react';
import { ProgressBar } from '../ui/ProgressBar';
import { metrics, type Metric } from '../../data/perfectDay';
interface MetricCardsProps {
  onOpenRecords: (recordSetId: string) => void;
}
const toneRing: Record<Metric['tone'], string> = {
  brand: 'group-hover:border-brand-300',
  teal: 'group-hover:border-teal-300',
  danger: 'group-hover:border-danger-300',
  navy: 'group-hover:border-navy-300'
};
const toneValue: Record<Metric['tone'], string> = {
  brand: 'text-navy-900',
  teal: 'text-navy-900',
  danger: 'text-danger-600',
  navy: 'text-navy-900'
};
const comparisonTone = {
  up: {
    classes: 'text-success-700',
    icon: TrendingUpIcon
  },
  down: {
    classes: 'text-danger-600',
    icon: TrendingDownIcon
  },
  flat: {
    classes: 'text-navy-500',
    icon: MinusIcon
  }
};
export function MetricCards({
  onOpenRecords
}: MetricCardsProps) {
  return <section aria-labelledby="daily-metrics-heading" data-id="element-20" data-mp="1q6dz8cz8ihcl">
      <h2 id="daily-metrics-heading" className="sr-only" data-id="element-21" data-mp="1q5ma9l057hva">
        Daily summary metrics
      </h2>
      <ul className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4" data-id="element-22" data-mp="1v45yjs27l5qt">
        {metrics.map(metric => {
        const comparison = metric.comparison ? comparisonTone[metric.comparison.direction] : null;
        const ComparisonIcon = comparison?.icon;
        return <li key={metric.id} data-id="element-23" data-mp="17933318wg41d">
              <button type="button" onClick={() => onOpenRecords(metric.recordSetId)} aria-label={`${metric.label}: ${metric.value}. View underlying records.`} className={`group flex h-full w-full flex-col rounded-2xl border border-navy-100 bg-white p-4 text-left shadow-card transition-colors hover:bg-navy-50/40 ${toneRing[metric.tone]}`} data-id="element-24" data-mp="1c6mqorrhlt5z">
                <div className="flex items-start justify-between gap-2" data-id="element-25" data-mp="2xjfynfmuohm0">
                  <p className="text-sm font-semibold text-navy-600" data-id="element-26" data-mp="xhpy0kbi1v5h">
                    {metric.label}
                  </p>
                  <ChevronRightIcon className="h-4 w-4 shrink-0 text-navy-300 group-hover:text-navy-600" aria-hidden="true" data-id="element-27" data-mp="sjene7ddrgm7" />
                </div>
                <p className={`mt-2 text-3xl font-bold leading-none ${toneValue[metric.tone]}`} data-id="element-28" data-mp="12gjd2h6fpu7r">
                  {metric.value}
                </p>
                <p className="mt-1.5 text-xs text-navy-500" data-id="element-29" data-mp="9snhjfslq8ck">{metric.support}</p>

                {metric.progress ? <ProgressBar className="mt-3" size="sm" tone="teal" value={metric.progress.current} max={metric.progress.target} label={`${metric.label} progress`} data-id="element-30" data-mp="nkk5r8r5fy3o" /> : null}

                {metric.comparison && ComparisonIcon ? <p className={`mt-3 inline-flex items-center gap-1 text-xs font-medium ${comparison?.classes}`} data-id="element-31" data-mp="3d2tlk0v10dc9">
                    <ComparisonIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-32" data-mp="3hvmrut657tqg" />
                    {metric.comparison.text}
                  </p> : null}

                <span className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-brand-600 opacity-0 transition-opacity group-hover:opacity-100 group-focus-visible:opacity-100" data-id="element-33" data-mp="384ic3r8n84uk">
                  View records
                  <ArrowUpRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-34" data-mp="4l76ku08jnya" />
                </span>
              </button>
            </li>;
      })}
      </ul>
    </section>;
}